import { actionTypes } from "./actions";

const initialState = null;

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.AUDIT_RESEND_ASSIGNMENT_EMAIL_GET_REQUEST: {
            const assignment_id = action.payload;
            return assignment_id;
        }
        case actionTypes.AUDIT_RESEND_AUDIT_EMAIL_POST_REQUEST: {
            const audit = action.payload;
            return audit;
        }
        default: {
            return state;
        }
    }
}
